document.addEventListener('DOMContentLoaded', function() {
    // Slider setup
    var container = document.querySelector('.blog-content');
    var containerblog = document.querySelector(".blog-main");
    var nextButtonsBlog = containerblog ? containerblog.querySelectorAll('.next-arrow') : [];
    var prevButtonsBlog = containerblog ? containerblog.querySelectorAll('.prev-arrow') : [];

    if (container && nextButtonsBlog.length > 0 && prevButtonsBlog.length > 0) {
      // Calculate scroll amount based on the width of .article-main
      var articleMain = document.querySelector('.article-main');
      
      if (articleMain) {
        var slideWidth = articleMain.offsetWidth;
        var scrollAmount = slideWidth + 10; // Adding 10px extra for padding or gap

        // Attach event listeners to each next button
        nextButtonsBlog.forEach(function(nextButton) {
          nextButton.addEventListener('click', function() {
            console.log("nextButton click");
            container.scrollBy({
              left: scrollAmount,
              behavior: 'smooth'
            });
          });
        });

        prevButtonsBlog.forEach(function(prevButton) {
          prevButton.addEventListener('click', function() {
            console.log("prevButton click");
            container.scrollBy({
              left: -scrollAmount,
              behavior: 'smooth'
            });
          });
        });
      } else {
        console.error('Element with class .article-main not found');
      }
    } else {
      console.error('One or more elements not found:', { container, nextButtonsBlog, prevButton });
    }
  });